import { LOGIN_TOKEN } from '@/global/constants'
import { localCache } from '@/utils/cache'
import config from './config'
import HYRequest from './request'
// 打印环境配置（仅在开发/预览时打印，生产环境自动忽略）
// if (config.isDev || config.env === 'preview') {
//   console.log('当前环境配置信息：', {
//     环境类型: config.env,
//     接口基础地址: config.api.baseURL,
//     是否开发环境: config.isDev,
//     是否启用Mock: config.feature.enableMock,
//     静态资源域名: config.resource.staticDomain
//   })
// }
const hyRequest = new HYRequest({
  baseURL: config.api.baseURL,
  timeout: config.api.timeout,
  interceptors: {
    requestSuccessFn: (config) => {
      // console.log(`output->请求成功函数 返回`, config)
      // 每一个需要鉴权的请求都自动携带token
      const needAuth = config.needAuth !== false
      const token = localCache.getCache(LOGIN_TOKEN)
      if (needAuth && config.headers && token) {
        // 类型缩小
        config.headers.Authorization = 'Bearer ' + token
      }
      return config
    }
  }
})

export default hyRequest
